import React from 'react';

import http from 'api/http';
import { oilAPI } from 'api/requests';

import { downloadFile } from 'helpers';

export default ({user, applicationStatus, applicationId, name}) => {

  const downloadLetter = () => {
    http.get(oilAPI.downloadFormulaCertLetter(applicationId), {responseType: 'blob'})
      .then(({data}) => {
        downloadFile(data, `Formula_Certification_Letter_${name}.pdf`);
      });
  };

  return (
    <section className='scene_section'>
      <header>Downloads</header>
      <div className='detailsScene__downloads-section-buttons-wrapper'>
        <div className='detailsScene__downloads-section-button' onClick={downloadLetter}>
          Formulation Certification Letter
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Details/DownloadSection.jsx